import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import * as Sentry from '@sentry/react';
import App from './App';
import { theme } from './theme/theme';
import { initSentry } from './sentry';

// Initialize Sentry
initSentry();

// Mantine styles
import '@mantine/core/styles.css';
// Global styles
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
        <App />
      </Sentry.ErrorBoundary>
    </MantineProvider>
  </React.StrictMode>
);
